<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row :gutter="24">
        <el-form-item label="门店名称" >
          <el-input
              v-model="serchParams.dealerName"
              class="mb10"
              style="width: 240px"
              placeholder="请输入门店名称"
              clearable
          />
        </el-form-item>
        <el-form-item label="手机号" >
          <el-input
              v-model="serchParams.phone"
              class="mb10"
              style="width: 240px"
              placeholder="请输入手机号"
              clearable
          />
        </el-form-item>
<!--        <el-form-item label="状态" class="ml10">-->
<!--          <el-select v-model="serchParams.enabled" placeholder="请选择">-->
<!--            <el-option-->
<!--                v-for="item in options"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-button class="ml10 mb10" type="primary" @click="getList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div class="d-flex">
      <el-button class="ma" type="primary" @click="handleAddDealer('add')">+添加门店</el-button>
      <el-button class="ma ml10" type="primary" @click="importDealer" icon="el-icon-top" v-if="checkPermission(['import_dl'])">导入门店</el-button>
    </div>
    <commonTable :tableData="tableData" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange">
      <template v-slot:table>

        <el-table-column prop="dealerName" align="center" label="门店名称" />
        <el-table-column prop="code" align="center" label="店铺编码">
          <template slot-scope="scope">
            {{ scope.row.code || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="liaison" align="center" label="联系人">
          <template slot-scope="scope">
            {{ scope.row.liaison || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号">
          <template slot-scope="scope">
            {{ scope.row.phone || '--' }}
          </template>
        </el-table-column>
<!--        <el-table-column prop="departmentName" align="center" label="部门">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.departmentName || '&#45;&#45;' }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="leader" align="center" label="分公司">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.branchCompanyName || '&#45;&#45;' }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column align="center" width="200" label="门店地址">
          <template slot-scope="scope" v-if="scope.row.addressList">
            <div  v-for="(item,index) in scope.row.addressList.slice(0,scope.row.displayCount)" :key="index">
              {{item}}
            </div>
            <el-button
                type="text"
                :class="[scope.row.addressList && scope.row.addressList.length <= hiddenNum1 ? 'hideBtn' : '']"
                @click="scope.row.displayCount > hiddenNum1 ? hideList1(scope.row) : viewAll1(scope.row)">
              {{scope.row.displayCount > hiddenNum1 ? '收起' : '•••查看更多'}}
            </el-button>
          </template>
          <template slot-scope="scope" v-else>
            {{scope.row.address || '--'}}
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="销售区域">
          <template slot-scope="scope" v-if="scope.row.area">
            <div  v-for="item in scope.row.area.slice(0,scope.row.displayCount)" :key="item.id" >
              {{item.address?item.address:'--'}}
            </div>
            <el-button
                type="text"
                :class="[scope.row.area && scope.row.area.length <= hiddenNum ? 'hideBtn' : '']"
                @click="scope.row.displayCount > hiddenNum ? hideList(scope.row) : viewAll(scope.row)">
              {{scope.row.displayCount > hiddenNum ? '收起' : '•••查看更多'}}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editDealar(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteDealar(scope.row)" style="color: red" >删除</el-button>
            <el-button type="text" @click="setBlock(scope.row)" v-if="scope.row.enabled && checkPermission(['block'])" style="color: rgb(230, 162, 60)" >拉黑</el-button>
            <el-button type="text" @click="setBlock(scope.row)" v-if="!scope.row.enabled && checkPermission(['block'])" style="color: #74d7d5">恢复</el-button>
            <el-button type="text" @click="setJkBlock(scope.row)" v-if="checkPermission(['jk_block'])" style="color: #74d7d5">拉黑配置</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>

    <AddDealerDialog ref="addDealerDialog" @getList="getList"></AddDealerDialog>

      <dealer-block-log ref="dealerBlockLog" @getList="getList"></dealer-block-log>

    <import-dl-dialog ref="importDealerDialog" @getList="getList"></import-dl-dialog>
  </div>
</template>

<script>
  import AddDealerDialog from './components/AddDealerDialog'
  import commonTable from "@/components/common/commonTable";
  import { fetchDealList, fetchDeleteDeal,fetchBlockDealer } from '@/api/companyManage.js'
  import { checkPermission } from "@/directives/permission";
  import DealerBlockLog from "@/pages/dealerBlockLog/index.vue";
  import importDlDialog from "@/pages/dealerManage/components/importDlDialog.vue";
  export default {
    name: "dealerList",
    components: {
      commonTable,
      AddDealerDialog,
      DealerBlockLog,
      importDlDialog
    },
    data() {
      return {
        drawer: false,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        serchParams:{
          dealerName:'',
          enabled:'',
          phone:''
        },
        options:[
          {value:'',label:'全部'},
            {value:true,label:'正常'},
            {value:false,label:'拉黑'}
        ],
        hiddenNum:5,
        hiddenNum1:5
      };
    },
    created() {
      this.getList()
    },
    methods: {
      checkPermission,
      setJkBlock(row){
        this.$refs.dealerBlockLog.openDialog(row)
      },
      resetSearch(){
        this.serchParams.dealerName = ''
        this.serchParams.enabled = ''
        this.serchParams.phone = ''
        this.pageNum = 1
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddDealer(type, id) {
        this.$refs.addDealerDialog.openDialog(type, id, 'shop')
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: 1,
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
        }
        Object.assign(params, this.serchParams)
        fetchDealList(params).then(res => {
          res.data.list.forEach(item => {
            item.displayCount = this.hiddenNum
            if (item.address){
              item.addressList = item.address.split(',').map(str=>"•"+str)
            }
          })
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      editDealar(data) {
        this.$refs.addDealerDialog.openDialog('edit', data, 'shop')
      },
      deleteDealar(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该门店, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fetchDeleteDeal(JSON.stringify(params)).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      setBlock(data){
        let params = {
          id: data.id
        }
        this.$confirm('此操作将该代理商'+(data.enabled?'拉黑':'恢复为正常状态')+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fetchBlockDealer(JSON.stringify(params)).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      viewAll(row) {
        row.displayCount = row.area.length;
      },
      // 收起多出部分时，只取前5条
      hideList(row) {
        row.displayCount = this.hiddenNum;
      },
      viewAll1(row) {
        row.displayCount = row.addressList.length;
      },
      // 收起多出部分时，只取前5条
      hideList1(row) {
        row.displayCount = this.hiddenNum1;
      },
      importDealer(){
        this.$refs.importDealerDialog.openDialog()
      }
    }
  }
</script>

<style lang="scss" scoped>
.hideBtn {
  display: none;
}
</style>
